import React from 'react';
import { Switch, Redirect } from 'react-router-dom';

import { RouteWithLayout } from './components';
import {
  //Main as MainLayout,
  Minimal as MinimalLayout,
  VerificaAltenticacao
} from './layouts';

import {
  Dashboard as DashboardView,
  Entrar as EntrarView,
  Sair as SairView,
  ListaPropostas as ListaPropostasView,
  ListaPropostasPendentes as ListaPropostasPendentesView,
  ListaPropostasEmAverbacao as ListaPropostasEmAverbacaoView,
  ListaPropostasFuncEmpresa as ListaPropostasFuncEmpresaView,
  ListaPropostasIndeferidas as ListaPropostasIndeferidasView,
  ListaPropostasEmAnalise as ListaPropostasEmAnaliseView,
  ListaPropostasNovas as ListaPropostasNovasView,
  ListaPropostasImplantadas as ListaPropostasImplantadasView,
  ListaPropostasCanceladas as ListaPropostasCanceladasView,
  ResumoProposta as ResumoPropostaView,
  VisualizarDocs as VisualizarDocsView,
  IncluirPropostaPF as IncluirPropostaPFView,
  LinkVendedor as LinkVendedorView,
  ResumoSimples as ResumoSimplesView,
  Corretoras as CorretorasView,
  NovaCorretora as NovaCorretoraView,
  Planos as PlanosView,
  Faturas as FaturasView,
  NovoPlano as NovoPlanoView,
  Vendedores as VendedoresView,
  NovoVendedor as NovoVendedorView,
  ListaDependentes as ListaDependetesView,
  //Backoffice as BackofficeView,

  IncluirDependente as IncluirDependenteView,
  IncluirPropostaPJ as IncluirPropostaPJView,
  ListaPropostasPJCanceladas as ListaPropostasPJCanceladasView,
  ResumoPropostaPJ as ResumoPropostaPJView,
  ListaPropostasPJEmAnalise as ListaPropostasPJEmAnaliseView,
  ListaPropostasPJImplantadas as ListaPropostasPJImplantadasView,
  ListaPropostasPJIndeferidas as ListaPropostasPJIndeferidasView,
  ListaPropostasPJPendentes as ListaPropostasPJPendentesView,
  ListaPropostasPJConfPendentes as ListaPropostasPJConfPendentesView,
  ListaPropostasPJEmProcessamento as ListaPropostasPJEmProcessamentoView,
  ListaPropostasPJ as ListaPropostasPJView,
} from './views/Painel';

const Routes = () => {
  return (
    <Switch>
      <Redirect
        exact
        from={`${process.env.PUBLIC_URL}/`}
        to={`${process.env.PUBLIC_URL}/dashboard`}
      />
      <RouteWithLayout
        component={DashboardView}
        exact
        layout={VerificaAltenticacao}
        path={`${process.env.PUBLIC_URL}/dashboard`}
      />
      <RouteWithLayout
        component={EntrarView}
        exact
        layout={MinimalLayout}
        path={`${process.env.PUBLIC_URL}/entrar`}
      />
      <RouteWithLayout
        component={SairView}
        exact
        layout={MinimalLayout}
        path={`${process.env.PUBLIC_URL}/sair`}
      />
      <RouteWithLayout
        component={ListaPropostasView}
        exact
        layout={VerificaAltenticacao}
        path={`${process.env.PUBLIC_URL}/geralpf`}
      />
      <RouteWithLayout
        component={ListaPropostasPendentesView}
        exact
        layout={VerificaAltenticacao}
        path={`${process.env.PUBLIC_URL}/pendentespf`}
      />
      <RouteWithLayout
        component={ListaPropostasEmAverbacaoView}
        exact
        layout={VerificaAltenticacao}
        path={`${process.env.PUBLIC_URL}/emaverbacaopf`}
      />
      <RouteWithLayout
        component={ListaPropostasFuncEmpresaView}
        exact
        layout={VerificaAltenticacao}
        path={`${process.env.PUBLIC_URL}/funcempresa`}
      />
      <RouteWithLayout
        component={ListaPropostasIndeferidasView}
        exact
        layout={VerificaAltenticacao}
        path={`${process.env.PUBLIC_URL}/indeferidaspf`}
      />
      <RouteWithLayout
        component={ListaPropostasEmAnaliseView}
        exact
        layout={VerificaAltenticacao}
        path={`${process.env.PUBLIC_URL}/emanalisepf`}
      />
      <RouteWithLayout
        component={ListaPropostasNovasView}
        exact
        layout={VerificaAltenticacao}
        path={`${process.env.PUBLIC_URL}/novaspf`}
      />
      <RouteWithLayout
        component={ListaPropostasImplantadasView}
        exact
        layout={VerificaAltenticacao}
        path={`${process.env.PUBLIC_URL}/implantadaspf`}
      />
      <RouteWithLayout
        component={ListaPropostasCanceladasView}
        exact
        layout={VerificaAltenticacao}
        path={`${process.env.PUBLIC_URL}/canceladaspf`}
      />
      <RouteWithLayout
        component={ResumoPropostaView}
        exact
        layout={VerificaAltenticacao}
        path={`${process.env.PUBLIC_URL}/resumopf`}
      />
      <RouteWithLayout
        component={VisualizarDocsView}
        exact
        layout={VerificaAltenticacao}
        path={`${process.env.PUBLIC_URL}/visualizardoc`}
      />
      <RouteWithLayout
        component={IncluirPropostaPFView}
        exact
        layout={VerificaAltenticacao}
        path={`${process.env.PUBLIC_URL}/incluirpropostapf`}
      />
      <RouteWithLayout
        component={LinkVendedorView}
        exact
        layout={VerificaAltenticacao}
        path={`${process.env.PUBLIC_URL}/linkvendedor`}
      />
      <RouteWithLayout
        component={ResumoSimplesView}
        exact
        layout={VerificaAltenticacao}
        path={`${process.env.PUBLIC_URL}/resumosimples`}
      />
      <RouteWithLayout
        component={CorretorasView}
        exact
        layout={VerificaAltenticacao}
        path={`${process.env.PUBLIC_URL}/corretoras`}
      />
      <RouteWithLayout
        component={NovaCorretoraView}
        exact
        layout={VerificaAltenticacao}
        path={`${process.env.PUBLIC_URL}/novacorretora`}
      />
      <RouteWithLayout
        component={VendedoresView}
        exact
        layout={VerificaAltenticacao}
        path={`${process.env.PUBLIC_URL}/vendedores`}
      />
      <RouteWithLayout
        component={NovoVendedorView}
        exact
        layout={VerificaAltenticacao}
        path={`${process.env.PUBLIC_URL}/novovendedor`}
      />
            <RouteWithLayout
        component={PlanosView}
        exact
        layout={VerificaAltenticacao}
        path={`${process.env.PUBLIC_URL}/planos`}
      />
      <RouteWithLayout
        component={FaturasView}
        exact
        layout={VerificaAltenticacao}
        path={`${process.env.PUBLIC_URL}/faturas`}
      />
      <RouteWithLayout
        component={NovoPlanoView}
        exact
        layout={VerificaAltenticacao}
        path={`${process.env.PUBLIC_URL}/novoplano`}
      />
      <RouteWithLayout
        component={ListaDependetesView}
        exact
        layout={VerificaAltenticacao}
        path={`${process.env.PUBLIC_URL}/listadependentes`}
      />
      <RouteWithLayout
        component={IncluirDependenteView}
        exact
        layout={VerificaAltenticacao}
        path={`${process.env.PUBLIC_URL}/resumodependentes`}
      />

      <RouteWithLayout
        component={IncluirPropostaPJView}
        exact
        layout={VerificaAltenticacao}
        path={`${process.env.PUBLIC_URL}/incluirpropostapj`}
      />
      <RouteWithLayout
        component={ResumoPropostaPJView}
        exact
        layout={VerificaAltenticacao}
        path={`${process.env.PUBLIC_URL}/resumopj`}
      />
      <RouteWithLayout
        component={ListaPropostasPJView}
        exact
        layout={VerificaAltenticacao}
        path={`${process.env.PUBLIC_URL}/geralpj`}
      />
      <RouteWithLayout
        component={ListaPropostasPJCanceladasView}
        exact
        layout={VerificaAltenticacao}
        path={`${process.env.PUBLIC_URL}/canceladaspj`}
      />
      <RouteWithLayout
        component={ListaPropostasPJPendentesView}
        exact
        layout={VerificaAltenticacao}
        path={`${process.env.PUBLIC_URL}/pendentespj`}
      />
      <RouteWithLayout
        component={ListaPropostasPJEmAnaliseView}
        exact
        layout={VerificaAltenticacao}
        path={`${process.env.PUBLIC_URL}/emanalisepj`}
      />
      <RouteWithLayout
        component={ListaPropostasPJIndeferidasView}
        exact
        layout={VerificaAltenticacao}
        path={`${process.env.PUBLIC_URL}/indeferidaspj`}
      />
      <RouteWithLayout
        component={ListaPropostasPJImplantadasView}
        exact
        layout={VerificaAltenticacao}
        path={`${process.env.PUBLIC_URL}/implantadaspj`}
      />
      <RouteWithLayout
        component={ListaPropostasPJConfPendentesView}
        exact
        layout={VerificaAltenticacao}
        path={`${process.env.PUBLIC_URL}/confpendentespj`}
      />
      <RouteWithLayout
        component={ListaPropostasPJEmProcessamentoView}
        exact
        layout={VerificaAltenticacao}
        path={`${process.env.PUBLIC_URL}/emprocessamentopj`}
      />
      {/* <RouteWithLayout
        component={BackofficeView}
        exact
        layout={VerificaAltenticacao}
        path={`${process.env.PUBLIC_URL}/backoffice`}
      /> */}
      {/* <RouteWithLayout
        component={UserListView}
        exact
        layout={MainLayout}
        path={`${process.env.PUBLIC_URL}/users`}
      />
      <RouteWithLayout
        component={ProductListView}
        exact
        layout={MainLayout}
        path={`${process.env.PUBLIC_URL}/products`}
      />
      <RouteWithLayout
        component={TypographyView}
        exact
        layout={MainLayout}
        path={`${process.env.PUBLIC_URL}/typography`}
      />
      <RouteWithLayout
        component={IconsView}
        exact
        layout={MainLayout}
        path={`${process.env.PUBLIC_URL}/icons`}
      />
      <RouteWithLayout
        component={AccountView}
        exact
        layout={MainLayout}
        path={`${process.env.PUBLIC_URL}/account`}
      />
      <RouteWithLayout
        component={SettingsView}
        exact
        layout={MainLayout}
        path={`${process.env.PUBLIC_URL}/settings`}
      />
      <RouteWithLayout
        component={SignUpView}
        exact
        layout={MinimalLayout}
        path={`${process.env.PUBLIC_URL}/sign-up`}
      />
      <RouteWithLayout
        component={NotFoundView}
        exact
        layout={MinimalLayout}
        path={`${process.env.PUBLIC_URL}/not-found`}
      /> */}
      <Redirect to={`${process.env.PUBLIC_URL}/not-found`} />
    </Switch>
  );
};

export default Routes;
